import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/useAuth';
import { AdminShell } from './components/AdminShell';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { TodayPage } from './pages/TodayPage';
import { CalendarPage } from './pages/CalendarPage';
import { BookingsPage } from './pages/BookingsPage';
import { ClientsPage } from './pages/ClientsPage';
import { GLP1Page } from './pages/GLP1Page';
import { MoneyPage } from './pages/MoneyPage';
import { AppContentPage } from './pages/AppContentPage';
import PagesEditor from './pages/PagesEditor';
import BlocksPage from './pages/BlocksPage';
import NavigationPage from './pages/NavigationPage';
import { ReviewPage } from './pages/ReviewPage';
import { UsersPage } from './pages/UsersPage';
import { SettingsPage } from './pages/SettingsPage';

export default function App() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="admin-login">
        <div className="admin-login__card">
          <p className="admin-login__sub">Loading…</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* Full-screen takeover — the Pages editor renders OUTSIDE AdminShell
          (fixed inset-0; its topbar drawer carries the admin nav). It edits
          pages AND the record lists (?list=drips|services|faqs|steps|testimonials). */}
      <Route path="/pages" element={<PagesEditor />} />
      {/* The old per-list editors now live in the Pages editor's Lists mode —
          keep their URLs working for bookmarks. */}
      <Route path="/menu" element={<Navigate to="/pages?list=drips" replace />} />
      <Route path="/services" element={<Navigate to="/pages?list=services" replace />} />
      <Route path="/faqs" element={<Navigate to="/pages?list=faqs" replace />} />
      <Route path="/steps" element={<Navigate to="/pages?list=steps" replace />} />
      <Route path="/testimonials" element={<Navigate to="/pages?list=testimonials" replace />} />
      <Route path="/content" element={<Navigate to="/pages" replace />} />
      <Route path="/" element={<AdminShell />}>
        <Route index element={<TodayPage />} />
        <Route path="today" element={<TodayPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="glp1" element={<GLP1Page />} />
        <Route path="money" element={<MoneyPage />} />
        <Route path="blocks" element={<BlocksPage />} />
        <Route path="review" element={<ReviewPage />} />
        <Route path="navigation" element={<NavigationPage />} />
        <Route path="app" element={<AppContentPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
